module.exports = __webpack_public_path__ + "img/AL275-1-EN.c4756e58.png";